import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import tinycolor from 'tinycolor2';
import scmp, { translateThemeConsts } from 'components/StyledComp';

const propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

function calcColor(color, props) {
  return translateThemeConsts(color, props);
}

function calcHoverColor(color, props) {
  const translated = translateThemeConsts(color, props);
  return tinycolor(translated).lighten(10).toString();
}

function calcActiveColor(color, props) {
  const translated = translateThemeConsts(color, props);
  return tinycolor(translated).darken(10).toString();
}

const StyledButton = styled(scmp.AntdButton)`
  background-color: ${props => calcColor(props.backgroundColor, props)};
  border-color: ${props => calcColor(props.borderColor || props.backgroundColor, props)};
  text-align: center;

  &:hover, &:focus {
    background-color: ${props => calcHoverColor(props.backgroundColor, props)};
    border-color: ${props => calcHoverColor(props.borderColor || props.backgroundColor, props)};
  }

  &:active, &.active {
    background-color: ${props => calcActiveColor(props.backgroundColor, props)};
    border-color: ${props => calcActiveColor(props.borderColor || props.backgroundColor, props)};
  }
`;

const CustomButton = ({ backgroundColor, borderColor, onClick, children, ...otherProps }) => {
  const onClickFn = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <StyledButton
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      {...otherProps}
      onClick={onClickFn}
    >
      {children}
    </StyledButton>
  );
};

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
CustomButton.propTypes = propTypes;

export default CustomButton;
